import React, { useMemo } from "react";
import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table";

const TotalTataCareCuponTable = ({ data = [] }) => {
  // Format data safely
  const formattedData =
    data?.map((item) => ({
      chassisNo: item.chassis_no || "-",
      totalCupon: item.total_amount_coupon_generated || 0,
    })) || [];

  // Define columns
  const columns = useMemo(
    () => [
      {
        header: "Chassis No.",
        accessorKey: "chassisNo",
      },
      {
        header: "Total Tata Care Cupon",
        accessorKey: "totalCupon",
      },
    ],
    []
  );

  const table = useReactTable({
    data: formattedData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-2">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded-lg text-sm text-center">
          {/* Header */}
          <thead className="bg-[#1467B3] text-white">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border-b px-4 py-2 font-semibold text-center"
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {/* Body */}
          <tbody>
            {table.getRowModel().rows.length > 0 ? (
              table.getRowModel().rows.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id} className="border-b px-4 py-2 text-center">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-4 text-gray-500"
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TotalTataCareCuponTable;
